var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.666 17l8.65-5-8.65-5v10zM32.933 3.95c.216.784.366 1.833.466 3.167.117 1.333.167 2.483.167 3.483l.1 1.4c0 3.65-.267 6.334-.733 8.05-.417 1.5-1.384 2.467-2.884 2.883-.783.217-2.216.367-4.416.467-2.167.117-4.15.167-5.984.167l-2.65.1c-6.983 0-11.333-.267-13.05-.734-1.5-.416-2.466-1.383-2.883-2.883C.85 19.267.7 18.217.6 16.884A40.1 40.1 0 01.433 13.4l-.1-1.4c0-3.65.266-6.333.733-8.05.417-1.5 1.383-2.466 2.883-2.883C4.733.85 6.166.7 8.366.6c2.167-.117 4.15-.167 5.983-.167l2.65-.1c6.984 0 11.334.267 13.05.734 1.5.417 2.467 1.383 2.884 2.883z",
    fill: "#fff"
  })));
}
export default SvgYoutubeWhite;